module.exports = __webpack_public_path__ + "static/media/WEF-norming-Intro-lower.31efc83a.mp3";